import { getDeleteEmailTemplateApi, getEmailTemplatesApi, getGetEmailTemplateByIdApi, getPatchEmailTemplateApi, postEmailTemplateApi } from "../sharedData/emailTemplateAPIs";

const { default: axios } = require("axios");
const { tokenConfig } = require("../utils/apiConfig");

/**
* @param {Function,Function}
*/
export async function getEmailTemplates(succCallbackFunc, errCallbackFunc) {
    return await axios
        .get(getEmailTemplatesApi, tokenConfig())
        .then(res => succCallbackFunc(res.data))
        .catch(err => {
            if (err instanceof String) { errCallbackFunc(err) }
            else { errCallbackFunc(JSON.stringify(err)) }
        })
}
/**
* @param {String,Function,Function}
*/
export async function getEmailTemplateById(id, succCallbackFunc, errCallbackFunc) {
    return await axios
        .get(getGetEmailTemplateByIdApi(id), tokenConfig())
        .then(res => succCallbackFunc(res.data))
        .catch(err => {
            if (err instanceof String) { errCallbackFunc(err) }
            else { errCallbackFunc(JSON.stringify(err)) }
        })
}

/**
* @param {Object,Function,Function}
*/
export async function createEmailTemplates(reqBody, succCallbackFunc, errCallbackFunc) {
    return await axios
        .post(postEmailTemplateApi, reqBody, tokenConfig())
        .then(res => succCallbackFunc(res.data))
        .catch(err => {
            if (err instanceof String) { errCallbackFunc(err) }
            else { errCallbackFunc(JSON.stringify(err)) }
        })
}

/**
* @param {Object,Function,Function}
*/
export async function patchEmailTemplate(reqBody, succCallbackFunc, errCallbackFunc) {
    return await axios
        .patch(getPatchEmailTemplateApi(reqBody._id), reqBody, tokenConfig())
        .then(res => succCallbackFunc(res.data))
        .catch(err => {
            if (err instanceof String) { errCallbackFunc(err) }
            else { errCallbackFunc(JSON.stringify(err)) }
        })
}


/**
* @param {String,Function,Function}
*/
export async function deleteEmailTemplate(id, succCallbackFunc, errCallbackFunc) {
    return await axios
        .delete(getDeleteEmailTemplateApi(id), tokenConfig())
        .then(res => succCallbackFunc(res.data))
        .catch(err => {
            if (err instanceof String) { errCallbackFunc(err) }
            else { errCallbackFunc(JSON.stringify(err)) }
        })
}